export default __webpack_public_path__ + "static/media/park_linowy_regulamin.e1039af4.doc";